import React, { Component, Suspense } from "react";
import { withRouter } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import { Card } from "reactstrap";
import { Menu, Segment, Sidebar, Dropdown } from "semantic-ui-react";
import { ResponsiveBar } from "@nivo/bar";
import { BasicTooltip } from "@nivo/tooltip";
import { Skeleton, DatePicker, Button as ButtonAnt, Switch } from "antd";
import Fade from "react-reveal/Fade";
import { connect } from "react-redux";
import { Services } from "../../../repositories/clients/Services";
import axios from "axios";
import _ from "lodash";
import { IconNewComment } from "./components/img";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import Loader from "../../Global/Loader";
import FormFiltros from "./model/form";

import { Link } from "react-router-dom";
import "./styles.scss";
import Swal from "sweetalert2";

import { withNamespaces } from "react-i18next";
import { saveAs } from "file-saver";

import "./styles.scss";
import CountCard from "../Components/CountCard";
import { FullLoader } from "../Home/components/Loader";
import Chart from "react-google-charts";
import DataTable from "../Components/DataTable";
import { openNotification } from "../Components/Notification";

const Comments = React.lazy(() => import("../Components/Comments"));

const colors = [
  "#0048FF",
  "#0A54FF",
  "#1560FF",
  "#206CFF",
  "#2B78FF",
  "#3684FF",
  "#4190FF",
  "#4C9CFF",
  "#57A8FF",
  "#62B4FF",
  "#6DC0FF",
  "#78CCFF",
  "#83D8FF",
  "#8EE4FF",
  "#99F0FF",
];

const dateNow = new Date();

const { RangePicker } = DatePicker;

class OrderListCommponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameXlsx: `${this.props.t("po_list")} - ${dateNow.getFullYear() +
        "" +
        (dateNow.getMonth() + 1).toString().padStart(2, "0") +
        "" +
        dateNow.getDate().toString().padStart(2, "0")
        }`,
      isMovil: false,
      loadercomments: false,
      loadingTable: false,
      viewModalComments: false,
      commentsData: [],
      users: [],
      rolId: this.props._rolId,
      userId: this.props._user,
      scrollLine: false,
      orders: [],
      data: [],
      advancedObj: [],
      catalogCombo: [],
      advancedSearch: {},
      clientesSelect: this.props.clients
        ? JSON.stringify(this.props.clients)
        : "[0]",
      activePage: 1,
      limit: 10,
      numberPage: 1,
      filtros: "",
      filterOpen: false,
      url: "",
      loading: true,
      columns: [
        {
          label: "",
          id: "commentView",
          key: "commentViewAction",
          minWidth: 45,
          maxWidth: 45,
          noclick: true,
          custom: (value, triggerFn) => (
            <div
              title={this.props.t("comments")}
              onClick={() => {
                this.setState(
                  {
                    loadercomments: true,
                    viewModalComments: true,
                  },
                  () => this.getComments(value)
                );
              }}
            >
              {value.NewComments ? (
                <IconNewComment></IconNewComment>
              ) : (
                <span className="icon-comments icons-front-module" />
              )}
            </div>
          ),
        },
        {
          label: "",
          key: "",
          CollapseTable: true,
          flatColor: true,
          keydatavalidate: "Status",
          minWidth: 30,
          maxWidth: 30,
        },
        {
          label: "",
          key: "PriorityPO",
          minWidth: 45,
          maxWidth: 40,
          custom: (value) => {
            return (
              value.PriorityPO === "1" && (
                <span
                  className="icon-priority-shipments icons-front-module orange"
                  title={this.props.t("priority_po")}
                />
              )
            );
          },
        },
        {
          label: "",
          key: "Issue",
          minWidth: 45,
          maxWidth: 45,
          custom: (value) => {
            return value.Issue === '1' && (
              <span className="icon-po-priorities icons-front-module" title={this.props.t("po_management_list_priority_issue")} />
            );
          },
        },
        {
          label: this.props.t("po_no"),
          key: "PONumber",
          minWidth: 150,
          maxWidth: 200,
          custom: (value) => (
            <Link
              to={"/supplier-management-detail/" + value.POId}
              className="underline-link"
            >
              {value.PONumber}
            </Link>
          ),
        },
        {
          label: this.props.t("status"),
          key: "StatusPo",
          minWidth: 150,
          maxWidth: 200,
          custom: (value) => (
            <span
              className={
                value.StatusIdPo !== 71
                  ? "badge badge-euro"
                  : "badge badge-euro-created"
              }
            >
              {value.StatusPo}
            </span>
          ),
        },
        { label: this.props.t("company"), key: "CustomerName", minWidth: 200 },
        { label: this.props.t("shipper"), key: "SupplierNameEuro", minWidth: 200 },
        {
          label: this.props.t("consignee"),
          key: "ConsigneeName",
          minWidth: 200,
        },
        {
          label: this.props.t("transport_mode"),
          key: "TransportMode",
          minWidth: 180,
        },
        {
          label: this.props.t("required_at_destination"),
          key: "requireddestinationdate",
          minWidth: 180,
        },
        { label: this.props.t("creation"), key: "createdate", minWidth: 150 },
      ],

      subTable: [
        { label: this.props.t("item_line"), key: "LineID", minWidth: 120 },
        { label: this.props.t("item_no"), key: "ItemNo", minWidth: 120 },
        {
          label: this.props.t("item_description"),
          key: "Description",
          minWidth: 250,
          limitString: 50,
        },
        {
          label: this.props.t("status"),
          key: "Status",
          minWidth: 150,
          maxWidth: 200,
          custom: (value) => (
            <span class="badge badge-euro">{value.Status}</span>
          ),
        },
        {
          label: this.props.t("item_qty_ordered"),
          key: "QTYOrdered",
          minWidth: 120,
        },
        {
          label: this.props.t("item_qty_confirmed"),
          key: "QTYConfirmed",
          minWidth: 120,
        },
        {
          label: this.props.t("item_request_charge"),
          key: "RequiredCagoReady",
          minWidth: 150,
        },
        {
          label: this.props.t("item_promised_charge"),
          key: "PromiseCargoReady",
          minWidth: 200,
        },
        {
          label: this.props.t("item_real_charge"),
          key: "ActualCargoReady",
          minWidth: 150,
        },
      ],
      searchOnInit: false,
      searchText: "",
      POId: 0,
      openComments: false,
      handleResCom: "unset",
      isSearchComments: true,
      tableLoader: false,
      totalCardsInfo: [],
      totalCardsConf: [
        {
          id: 1,
          key: "Tipo",
          keyTotal: "Total",
          colorClass: "bg-maritimo",
          image: (
            <span className="icon-active-orders icons-cards-totals"></span>
          ),
          xl: 3,
          md: 6,
          sm: 12,
          propertiesIcon: "col-3 d-flex align-items-center rounded-left2",
          propertiesTitle: "col-9 rounded-right2 endPosition",
        },
        {
          id: 2,
          key: "Tipo",
          keyTotal: "Total",
          colorClass: "bg-maritimo",
          image: <span className="icon-confirm icons-cards-totals"></span>,
          xl: 3,
          md: 6,
          sm: 12,
          propertiesIcon: "col-3 d-flex align-items-center rounded-left2",
          propertiesTitle: "col-9 rounded-right2 endPosition",
        },
        {
          id: 3,
          key: "Tipo",
          keyTotal: "Total",
          colorClass: "bg-maritimo",
          image: <span className="icon-delay icons-cards-totals"></span>,
          xl: 3,
          md: 6,
          sm: 12,
          propertiesIcon: "col-3 d-flex align-items-center rounded-left2",
          propertiesTitle: "col-9 rounded-right2 endPosition",
        },
        {
          id: 4,
          key: "Tipo",
          keyTotal: "Total",
          colorClass: "bg-tcc",
          image: (
            <span className="icon-priority-shipments icons-cards-totals"></span>
          ),
          xl: 3,
          md: 6,
          sm: 12,
          propertiesIcon: "col-3 d-flex align-items-center rounded-left2",
          propertiesTitle: "col-9 rounded-right2 endPosition",
        },
      ],
      totalStatus: [],
      creationTendency: [],
      maxTendencia: 0,
      orderHeaders: [
        this.props.t("po_no"),
        this.props.t("status"),
        this.props.t("company"),
        this.props.t("shipper"),
        this.props.t("consignee"),
        this.props.t("transport_mode"),
        this.props.t("required_at_destination"),
        this.props.t("creation"),
        this.props.t("line"),
        this.props.t("item"),
        this.props.t("item_description"),
        this.props.t("status"),
        this.props.t("qty_ordered"),
        this.props.t("qty_confirmed"),
        this.props.t("uom"),
        this.props.t("request_ready"),
        this.props.t("promise_ready"),
        this.props.t("real_charge"),
      ],
      orderKeys: [
        "PONumber",
        "StatusPo",
        "CustomerName",
        "SupplierName",
        "ConsigneeName",
        "TransportMode",
        "RequiredDestinationDate",
        "createdate",
        "LineID",
        "ItemNo",
        "Description",
        "Status",
        "QTYOrdered",
        "QTYConfirmed",
        "UOMCode",
        "RequiredCagoReady",
        "PromiseCargoReady",
        "ActualCargoReady",
      ],
      priorityChecked: false,
      extraFilter: "",
      buttonLoadPO: ["1", "2", "3", "5", "6"].includes(props._rolId) ? (
        <div className="float-right">
          <Button
            color="primary"
            className="d-flex align-items-center"
            title={this.props.t("create_new")}
            onClick={() => {
              this.props.history.push("/load-po");
            }}
          >
            <span className="icon-plus icon-button-add" />
            {this.props.t("po_management_upload")}
          </Button>
        </div>
      ) : (
        false
      ),
    };
  }

  componentDidMount = async () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMovil: isMobileDevice,
    });

    await this.createFilter();
    await this.getCatalogs();
    this.GenerateExtraFilter();
  };

  getComments = async (item, newComments) => {
    try {
      const { CustomerId, POId } = item;
      const moduleId = 10;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const { lng } = this.props;

      const params = new URLSearchParams({
        rowid: POId,
        moduleid: moduleId,
        general: false,
        zona: timezone,
        lang: lng,
      });

      const response = await axios.get(
        `${Services.PURCHASE_ORDER.path
        }supplier-management/orders-coments?${params.toString()}`
      );

      const comment = response.data.data.Comment;
      this.getUserMenciones(comment, CustomerId, POId, item);

      if (newComments) {
        openNotification("success", newComments);
      }
    } catch (error) {
      console.log("🚀 ~ OrderListCommponent ~ getComments= ~ error:", error);
    }
  };

  getUserMenciones = async (comentario, CustomerId, ShipmentId, item) => {
    const { userId } = this.state;

    this.setState({ loadercomments: true });

    try {
      const response = await axios.get(
        `${Services.PURCHASE_ORDER.path
        }supplier-management/user-mension?CustomerId=${encodeURIComponent(
          CustomerId
        )}&user=${encodeURIComponent(userId)}`
      );

      this.setState({
        commentsData: comentario,
        users: response.data.data,
        rowid: ShipmentId,
        itemCommenSelect: item,
        loadercomments: false,
      });
    } catch (error) {
      console.error("Error al obtener menciones de usuario:", error);
      this.setState({ loadercomments: false });
    }
  };

  newMessage = async (data) => {
    const { userId, rowid, itemCommenSelect } = this.state;

    const requestPayload = {
      ...data,
      Rowid: rowid,
      UserId: userId,
      ModuleId: 10,
      Mentions: [...new Set(data.Mentions || [])],
    };

    try {
      const response = await axios.post(
        `${Services.PURCHASE_ORDER.path}supplier-management/order-comments/add`,
        requestPayload
      );

      this.getComments(
        itemCommenSelect,
        this.props.t("comment_successfully_saved")
      );
    } catch (error) {
      console.error("Error al guardar comentario:", error);
    }
  };

  deleteMessage = async (idDelete, toggle) => {
    const { itemCommenSelect } = this.state;

    try {
      await axios.delete(
        `${Services.PURCHASE_ORDER.path}supplier-management/delete-comment/${idDelete}`
      );

      this.getComments(
        itemCommenSelect,
        this.props.t("comment_successfully_deleted")
      );

      toggle();
    } catch (error) {
      console.error("Error al eliminar comentario:", error);
    }
  };

  setOrderSearch = (value) => {
    if (this.state.search === value) return;

    this.setState(
      {
        search: value,
        activeInvoicePage: 1,
        numberPageInvoice: 1,
        numberPage: 1,
        loading: true,
      },
      () => {
        this.getOrdersList();
      }
    );
  };
  createFilter = async () => {
    let { advancedSearch } = this.state;
    advancedSearch = FormFiltros.map((filtro) => {
      return {
        id: filtro.id,
        options: filtro.options,
        isDate: filtro.type === "Datetime",
        UseIN: filtro.type === "Select",
        value: "",
        type: filtro.type,
        label: filtro.label,
        name: filtro.name,
        class: filtro.class,
        style: filtro.style,
      };
    });
    this.setState({ advancedSearch });
  };

  sendMessage = (text, type) => {
    Swal.fire({
      icon: type,
      confirmButtonColor: "#0561fc",
      confirmButtonText: "Ok",
      html: `<div class="text-center euro-title-form">
      ${text}
      </div>`,
      customClass: {
        confirmButton: "custom-width-btn swal",
      },
    });
  };

  resetAdvance = () => {
    let { advancedSearch, priorityChecked } = this.state;
    advancedSearch.map((advData) => {
      if (advData.type === "Datetime") {
        advData.value = "";
        advData.valueD = "";
      } else if (advData.id === "PriorityPO") {
        advData.value = priorityChecked ? 1 : [];
      } else {
        advData.value = [];
      }
      return advData;
    });
    this.setState({ advancedSearch, loading: true }, () => {
      this.getOrdersList();
      this.generateFilters();
    });
  };
  generateFilters = () => {
    let { catalogCombo, advancedSearch } = this.state;
    let { t } = this.props;
    let Inputs = [];

    Inputs.push(
      advancedSearch.map((e, i) => {
        if (e.type === "Select")
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                {" "}
                <span id={e.id} style={e.style}>
                  {t(e.label)}
                  {e.required === true ? (
                    <span style={{ color: "#ff0000" }}>*</span>
                  ) : (
                    ""
                  )}
                </span>
              </Fade>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Dropdown
                  className="NewClass"
                  onChange={this.handleChangeSelect(e.id)}
                  id={e.id}
                  options={catalogCombo[e.options]}
                  clearable
                  search
                  selection
                  fluid
                  value={e.value}
                  multiple
                  allowAdditions
                  noResultsMessage={t("no_results_found")}
                />
              </div>
            </div>
          );
        else if (e.type === "Datetime") {
          return (
            <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
              <Fade left opposite>
                <span id={t(e.label)} style={e.style}>
                  {" "}
                  <label>
                    {t(e.label)} {e.required == true ? <span>*</span> : ""}{" "}
                  </label>
                </span>
              </Fade>
              <RangePicker
                onChange={this.handleChangeDate(e.id)}
                size="middle"
                className="col-md-12"
                value={e.valueD}
                placeholder={[t("start_date"), t("end_date")]}
              />
              <Fade left opposite>
                <label style={e.style}>{e.error}</label>
              </Fade>
            </div>
          );
        }
      })
    );
    let NewInput = (
      <div className="row">
        <div className="col-12">
          <span
            className="icon-clear icons-front-module float-right"
            title={t("eliminate_filter")}
            onClick={this.resetAdvance}
          />
        </div>
        {Inputs}
      </div>
    );
    this.setState({
      filtros: NewInput,
    });
  };

  handleChangeSelect = (selected) => (evt, data) => {
    let { advancedSearch } = this.state;
    if (data.value) {
      advancedSearch.map((search) => {
        if (search.id == selected) {
          search.value = data.value;
        }
      });
    } else {
      advancedSearch.map((search) => {
        if (search.id == selected) {
          search.value = "";
        }
      });
    }
    this.setState({ advancedSearch, numberPage: 1, loading: true }, () => {
      this.generateFilters();
      this.getOrdersList();
    });
  };

  handleChangeDate = (name) => (event) => {
    let { advancedSearch } = this.state;

    try {
      advancedSearch.map((search) => {
        if (search.id == name) {
          let init = event ? event[0].format("YYYY-MM-DD") : "";
          let end = event ? event[1].format("YYYY-MM-DD") : "";
          search.value = { init, end };
          search.valueD = event ? [event[0], event[1]] : "";
          search.isDate = true;
        }
      });
      this.setState({ advancedSearch, numberPage: 1 }, () => {
        this.generateFilters();
        this.getOrdersList();
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  getCatalogs = async () => {
    const { clientesSelect, userId, rolId } = this.state;
    const { lng } = this.props;

    const payload = {
      client: clientesSelect,
      userId,
      lang: lng,
      rolId,
    };

    try {
      const { data } = await axios.post(
        `${Services.PURCHASE_ORDER.path}supplier-management/orders-catalogs`,
        payload
      );

      this.setState({ catalogCombo: data.data || [] }, () => {
        this.generateFilters();
        this.loadDashboardData();
      });
    } catch (error) {
      console.warn("Error al obtener catálogos:", error);
      this.setState({ loading: false });
    }
  };

  GenerateExtraFilter = () => {
    let { extraFilter, priorityChecked } = this.state;
    extraFilter = (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          marginLeft: "10px",
        }}
      >
        <span
          title={this.props.t("filter_priority_po")}
          className="icon-priority-shipments icons-front-module orange"
        />

        <Switch
          className="form-input-switch"
          checked={priorityChecked}
          onChange={this.handlePriorityChange}
          style={{ marginLeft: "1em" }}
        ></Switch>
      </div>
    );
    this.setState({ extraFilter });
  };

  handlePriorityChange = (event) => {
    let { advancedSearch, priorityChecked } = this.state;
    priorityChecked = event;
    let obj = advancedSearch.find((adv) => {
      return adv.id === "PriorityPO";
    });
    if (!obj) {
      advancedSearch.push({ id: "PriorityPO", val: "", UseIN: false });
    }
    if (!event) {
      advancedSearch = advancedSearch.filter(
        (value) => value.id !== "PriorityPO"
      );
    }
    advancedSearch.map((adv) => {
      if (adv.id === "PriorityPO") {
        if (event) {
          adv.value = 1;
        }
      }
      return adv;
    });

    this.setState({ advancedSearch, priorityChecked, numberPage: 1 }, () => {
      this.GenerateExtraFilter();
      this.getOrdersList();
    });
  };

  /*=============================================
  =            Get Graphics and totals                   =
  =============================================*/

  loadDashboardData = async () => {
    let { clientesSelect, userId, rolId } = this.state;
    const { lng } = this.props;

    let params = { customers: clientesSelect, userId, lng, rolId };

    try {
      let respGraph = await axios.post(
        `${Services.PURCHASE_ORDER.path}supplier-management/dashboard-data`,
        params
      );

      if (respGraph?.data) {
        const { totalInfo, totalStatus, creationTendency } =
          respGraph.data.data;

        this.setState(
          {
            totalCardsInfo: totalInfo,
            totalStatus: totalStatus,
          },
          () => {
            this.obtieneTendenciaCreacion(creationTendency)
            this.getOrdersList()
          }
        );
      }
    } catch (error) {
      console.log(
        "🚀 ~ OrderListCommponent ~ loadDashboardData= ~ error:",
        error.response?.data || error.message
      );
    }
  };

  obtieneTendenciaCreacion = async (data) => {
    let { tendenciaData, maxTendencia } = this.state;

    tendenciaData = [["x", this.props.t("tooltip_chart_tendency")]];
    data.map((mes) => {
      const valor = parseInt(mes[1]);
      tendenciaData.push([mes[0], valor]);
      if (valor > maxTendencia) {
        maxTendencia = mes.total;
      }
    });
    this.setState({ creationTendency: tendenciaData, maxTendencia });
  };

  getOrdersList = async () => {
    let {
      clientesSelect,
      numberPage,
      limit,
      search,
      advancedSearch,
      userId,
      rolId,
    } = this.state;

    const requestPayload = {
      client: clientesSelect,
      pag: numberPage,
      limit: limit,
      EsDTA: 0,
      search: search,
      query: {
        allData: false,
        noGroup: false,
      },
      advanced: advancedSearch,
      lang: this.props.lng,
      userId: userId,
      rolId: rolId,
    };

    this.setState({
      loading: true,
      url: `${Services.PURCHASE_ORDER.path
        }supplier-management/purchase-orders?search=${encodeURIComponent(
          this.state.search
        )}&allData=true`,
    });

    try {
      const { data } = await axios.post(
        `${Services.PURCHASE_ORDER.path}supplier-management/purchase-orders`,
        requestPayload
      );

      const processedData = data.data.data.map((item) => ({
        ...item,
        TraspormodeId: 1,
        QTYOrderedFormatted: new Intl.NumberFormat("en-US").format(
          item.QTYOrdered
        ),
      }));

      this.setState({
        data: processedData,
        dataAux: processedData,
        dataOut: processedData,
        totalPages: data.data.totalPage,
        loading: false,
      });
    } catch (error) {
      console.log("🚀 ~ OrderListCommponent ~ getOrdersList= ~ error:", error);
      this.setState({ loading: false });
    }
  };

  generateOrderExcel = async () => {
    this.setState({ excelInvoiceLoading: true });

    const {
      clientesSelect,
      numberPage,
      limit,
      search,
      advancedSearch,
      userId,
      orderHeaders,
      orderKeys,
      nameXlsx,
      rolId,
    } = this.state;

    const requestPayload = {
      client: clientesSelect,
      pag: numberPage,
      limit: limit,
      EsDTA: 0,
      search: search,
      query: {
        allData: true,
        noGroup: true,
      },
      advanced: advancedSearch,
      lang: this.props.lng,
      userId: userId,
      rolId: rolId,
    };

    try {
      const { data } = await axios.post(
        `${Services.PURCHASE_ORDER.path}supplier-management/purchase-orders`,
        requestPayload
      );

      const orderData = data.data.data;

      if (!orderData || orderData.length === 0) {
        throw new Error("No hay datos para exportar");
      }

      const parsedData = orderData.map((d) => ({
        ...d,
        TotalAmount: parseFloat(d.TotalAmount),
      }));

      const options = {
        headers: orderHeaders,
        keys: orderKeys,
        image: { name: "euro" },
        sheetName: this.props.t("orders"),
        font: "SF Pro Display",
      };

      const response = await axios.post(
        `${Services.REPORT.path}report/dynamic/xlsx`,
        {
          info: { config: {} },
          data: parsedData,
          options,
        }
      );

      if (response.data.base64) {
        const fileName = `${nameXlsx}.xlsx`;
        const linkSource = `data:application/xlsx;base64,${response.data.base64}`;
        saveAs(linkSource, fileName);
      } else {
        throw new Error("Error al generar el Excel");
      }
    } catch (error) {
      console.error("Error al exportar Excel:", error);
      openNotification("error", this.props.t("excel_export_fails"));
    } finally {
      this.setState({ excelInvoiceLoading: false });
    }
  };

  resetTable = () => {
    this.setState({ isSearchComments: false, handleResCom: "unset" }, () => {
      this.getOrdersList();
    });
  };

  changePage = (e, { activePageOrder }) => {
    this.setState(
      {
        numberPage: activePageOrder,
        loading: true,
      },
      () => {
        this.getOrdersList();
      }
    );
  };

  /*=============================================
  =            Selected Order                   =
  =============================================*/

  selectedOrder = (order) => {
    this.setState({
      POId: order.POId,
      PONumber: order.PONumber,
      openComments: true,
      handleResCom: "set",
      isSearchComments: true,
    });
  };

  handleClose = () => {
    this.setState({ openComments: false, isSearchComments: false });
  };

  setAdvanced = () => {
    let { filterOpen } = this.state;
    this.setState({ filterOpen: !filterOpen }, () => { });
  };

  getTotalChartsData = () => {
    let { totalStatus } = this.state;
    const data = totalStatus.map((item, index) => {
      let obj = {};
      obj[item.estatus] = item.total;
      obj.id = item.estatus;
      if (colors[index]) {
        obj.color = colors[index];
      } else {
        obj.color = "#0045F3";
      }
      return obj;
    });
    return data.reverse();
  };

  getTotalChartsKeys = () => {
    let { totalStatus } = this.state;
    const keys = totalStatus.map((item) => item.estatus);
    return keys;
  };

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      viewModalComments,
      loadercomments,
      commentsData,
      itemCommenSelect,
      users,
      rolId,
      userId,
      scrollLine,
      data,
      columns,
      loading,
      filtros,
      isMovil,
      totalCardsConf,
      totalCardsInfo,
      creationTendency,
      maxTendencia,
      loadingTable,
      buttonLoadPO,
    } = this.state;

    return (
      <ContentWrapper>
        <div className="content-heading">
          <span className="icon-supplier-management-2 icon-header" />
          {this.props.t("supplier_management_page_title")}
        </div>
        <CountCard config={totalCardsConf} data={totalCardsInfo} />
        <div className="row">
          <div className="col-xs-12 col-md-6 .col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title" style={{ fontWeight: "bold" }}>
                  {this.props.t("supplier_management_chart_total_by_status")}
                </div>
              </div>
              <div className="card-body" style={{ overflow: "hidden" }}>
                {loading ? (
                  <FullLoader />
                ) : (
                  <ResponsiveBar
                    data={this.getTotalChartsData()}
                    keys={this.getTotalChartsKeys()}
                    tooltip={(item) => {
                      return (
                        <BasicTooltip
                          id={item.data.id}
                          value={item.data[item.data.id]}
                          color={item.data.color}
                          enableChip
                        />
                      );
                    }}
                    margin={{ top: 20, right: 40, bottom: 50, left: 130 }}
                    padding={0.15}
                    layout="horizontal"
                    valueScale={{ type: "linear" }}
                    indexScale={{ type: "band", round: true }}
                    colors={colors}
                    borderColor={{
                      from: "color",
                      modifiers: [["darker", 1.6]],
                    }}
                    theme={{
                      axis: {
                        fontSize: "11px",
                        fontFamily: "SF Pro Display",
                        tickColor: "#000a2e",
                        ticks: {
                          line: {
                            stroke: "#000a2e",
                          },
                          text: {
                            fill: "#000a2e",
                            fontSize: "11px",
                            fontFamily: "SF Pro Display",
                          },
                        },
                        legend: {
                          text: {
                            fill: "#000a2e",
                            fontSize: "11px",
                            fontFamily: "SF Pro Display",
                          },
                        },
                      },
                    }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 25,
                      // legend: 'country',
                      legendPosition: "middle",
                      legendOffset: 32,
                      format: (value) =>
                        value.length > 17
                          ? `${value.substring(0, 17)}...`
                          : value, // Truncar a 10 caracteres
                    }}
                    axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      // legend: 'food',
                      legendPosition: "middle",
                      legendOffset: -40,
                      format: (value) =>
                        value.length > 17
                          ? `${value.substring(0, 17)}...`
                          : value, // Truncar a 10 caracteres
                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{
                      from: "color",
                      modifiers: [["darker", 1.6]],
                    }}
                    enableLabel={false}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 .col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title" style={{ fontWeight: "bold" }}>
                  {this.props.t("supplier_management_chart_trend")}
                </div>
              </div>
              <div className="card-body" style={{ overflow: "hidden" }}>
                {loading ? (
                  <FullLoader />
                ) : (
                  <div id="chartDashboard">
                    <Chart
                      style={{
                        width: "100%",
                      }}
                      className={"valueTable"}
                      chartType="LineChart"
                      loader={<div>Loading Chart</div>}
                      data={creationTendency}
                      options={{
                        width: "100%",
                        height: "300px",
                        curveType: "function",
                        legend: {
                          position: "none",
                        },
                        tooltip: { isHtml: true },
                        vAxis: {
                          minValue: 0,
                          viewWindow: { min: 0, max: maxTendencia + 1 },
                          textStyle: {
                            fontSize: 12,
                            color: "#000a2e",
                            fontName: "SF Pro Display",
                          },
                        },
                        hAxis: {
                          textStyle: {
                            fontSize: 12,
                            color: "#000a2e",
                            fontName: "SF Pro Display",
                          },
                        },
                        pointSize: 5,
                        series: {
                          0: {
                            color: "#000a2e",

                            lineWidth: 2,
                          },
                        },
                      }}
                      rootProps={{ "data-testid": "1" }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Card className="myCard">
          {loading ? (
            <Loader />
          ) : (
            <div>
              <Row>
                <Col md={12} xl={12}>
                  <Suspense fallback={<div>Loading...</div>}>
                    <Sidebar.Pushable as={Segment}>
                      <Sidebar
                        as={Menu}
                        animation="overlay"
                        icon="labeled"
                        style={{
                          maxHeight: "84%!important",
                          width: isMovil
                            ? window.innerWidth - window.innerWidth * 0.09
                            : 400,
                        }}
                        // style={{ maxHeight: "84%!important" }}
                        direction="right"
                        // onHide={() => setVisible(false)}
                        vertical
                        id="sidebarComents"
                        visible={viewModalComments}
                        className="custom-sidebar"
                      // width={window.innerWidth < 993 ? 'wide' : 'very wide'}
                      >
                        {/* <CardBody> */}
                        <div className=" col-12 close_container">
                          <div className="header_comments">
                            {itemCommenSelect ? itemCommenSelect.PONumber : ""}
                          </div>
                          <div
                            className="close_icon2"
                            onClick={() => {
                              this.setState({ viewModalComments: false });
                            }}
                          >
                            <ButtonAnt
                              size="small"
                              type="primary"
                              shape="circle"
                            >
                              X
                            </ButtonAnt>
                          </div>
                        </div>
                        <div style={{ height: "3em" }} className=" col-12">
                          {" "}
                        </div>

                        {loadercomments ? (
                          <Skeleton active paragraph={{ rows: 17 }} />
                        ) : (
                          <div className="col-12">
                            <Comments
                              commentTableList={true}
                              rolId={rolId}
                              userId={userId}
                              data={commentsData}
                              catalogs={users}
                              scrollLine={scrollLine}
                              funtionNewMessage={this.newMessage}
                              funtionDeleteMessage={this.deleteMessage}
                            />
                          </div>
                        )}
                      </Sidebar>
                      <Sidebar.Pusher>
                        <Segment basic>
                          <DataTable
                            // loadingTable={loadingTable}
                            downloadExcel={this.generateOrderExcel}
                            excelLoading={this.state.excelInvoiceLoading}
                            labelSelected={""}
                            search={this.state.search}
                            filtrosPanel={filtros}
                            startSubTable={1}
                            paddingSubtable="3%"
                            colspanSubTable={8}
                            showExcel={true}
                            panel={true}
                            data={data}
                            columnsTable={columns}
                            subTable={this.state.subTable}
                            handleSearch={this.setOrderSearch}
                            activePage={this.state.numberPage}
                            pages={this.state.totalPages}
                            OnPageChange={this.changePage}
                            sumaryInfo={this.state.sumaryInfo}
                            ExtraFilter={this.state.extraFilter}
                          // customButton={buttonLoadPO}
                          />
                        </Segment>
                      </Sidebar.Pusher>
                    </Sidebar.Pushable>
                  </Suspense>
                </Col>
              </Row>
            </div>
          )}
        </Card>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
  lang: state.header.lang,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(OrderListCommponent))
);
